import { motion } from "framer-motion";
import clsx from "clsx";

export default function ToggleSwitchSkeleton({
	displayLabel = true,
	hasLongLabel = false,
}: {
	displayLabel?: boolean;
	hasLongLabel?: boolean;
}) {
	return (
		<motion.div
			layout
			initial={{ height: 0, opacity: 0 }}
			animate={{ height: "auto", opacity: 1 }}
			exit={{ height: 0, opacity: 0 }}
			transition={{ duration: 0.25, ease: "easeInOut" }}
			style={{ overflow: "hidden" }}
			aria-busy="true"
			className="jF-flex jF-items-center jF-justify-between jF-gap-2"
		>
			{/* Label */}
			{displayLabel && (
				<div
					className={clsx(
						"jF-h-4 jF-rounded jF-bg-gray-200 jF-animate-pulse",
						hasLongLabel ? "jF-w-64" : "jF-w-40"
					)}
				/>
			)}

			{/* Switch */}
			<div className="jF-relative jF-inline-flex jF-h-6 jF-w-11 jF-flex-shrink-0 jF-rounded-full jF-bg-gray-200 jF-animate-pulse">
				{/* Thumb */}
				<div className="jF-absolute jF-left-0.5 jF-top-0.5 jF-h-5 jF-w-5 jF-rounded-full jF-bg-white" />
			</div>
		</motion.div>
	);
}
